import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/360_ai.svg'

const Ai360: React.FC<SvgIconProps> = props => (
  <SvgIcon
    sx={{ width: 'auto', height: theme => theme.spacing(4), mt: 1, ml: -1 }}
    viewBox={'0 0 60 30'}
    component={Icon}
    {...props}
    fill="currentColor"
  />
)
export default Ai360
